import React from "react";
import { Link, useParams } from "react-router-dom";

import { services } from "./serviceData";

import NavBar from "components/navbar";
import { LandingFooter } from "./LandingFooter";

const ServiceDetailScreen = () => {
    const { id } = useParams(); // Get the service ID from the URL
    const service = services.find(service => service.id === parseInt(id)); // Find the service by ID

    if (!service) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <div className="text-center">
                    <h1 className="text-4xl font-bold text-red-500 mb-4">Service Not Found</h1>
                    <p className="text-gray-600">The service you are looking for does not exist.</p>
                </div>
            </div>
        );
    }

    return (
        <>
            <NavBar />
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 py-12 px-4 sm:px-6 lg:px-8 mt-10">
                <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden">
                    {/* Image Section */}
                    <div className="relative h-64 sm:h-80 md:h-96">
                        <img
                            src={service.image}
                            alt={service.title}
                            className="w-full h-full object-cover object-center"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                        <div className="absolute bottom-6 left-6">
                            <h1 className="text-4xl sm:text-5xl font-bold text-white">{service.title}</h1>
                        </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-6 sm:p-8">
                        <p className="text-gray-700 text-lg leading-relaxed mb-6">
                            {service.description}
                        </p>

                        {/* Additional Details (Optional) */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <h2 className="text-xl font-semibold text-gray-800 mb-2">Key Features</h2>
                            <ul className="list-disc list-inside text-gray-600">
                                <li>Real-time updates and monitoring</li>
                                <li>Customizable reporting tools</li>
                                <li>24/7 customer support</li>
                            </ul>
                        </div>

                        {/* Back Button (Optional) */}
                        <div className="mt-8">
                            <Link
                                to="/" // Navigates to the home page
                                className="inline-flex items-center px-6 py-2 rounded-full border border-red-500 text-red-500 font-medium transition-all duration-300 hover:bg-red-500 hover:text-white"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 mr-2"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                Back to Home
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <LandingFooter />
        </>
    );
}
    export default ServiceDetailScreen;